<div class="lv-spinner" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
<div class="lv-headline">
  <div [innerHTML]="'Treffer für ' + getSearchParams()"></div>
  <div class="lv-dialog-icon-close">
    <mat-icon [svgIcon]="'Times'" (click)="closeDialog()"></mat-icon>
  </div>
</div>
<table mat-table [dataSource]="dataSource" class="lv-kunden-treffer-table" matSort>
  <ng-container matColumnDef="kundennummer">
    <th mat-header-cell *matHeaderCellDef>Kunden-<br>nummer</th>
    <td mat-cell *matCellDef="let element">{{element.knr}}</td>
  </ng-container>
  <ng-container matColumnDef="vorname">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vorname</th>
    <td mat-cell *matCellDef="let element">{{element.vorname}}</td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nachname</th>
    <td mat-cell *matCellDef="let element">{{element.name}}</td>
  </ng-container>
  <ng-container matColumnDef="geburtsdatum">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Geburtsdatum</th>
    <td mat-cell *matCellDef="let element">{{formatDate(element.geburtsdatum)}}</td>
  </ng-container>
  <ng-container matColumnDef="strasse">
    <th mat-header-cell *matHeaderCellDef>Straße/Hausnummer</th>
    <td mat-cell *matCellDef="let element">{{element.strasse}} {{element.hausnummer}}</td>
  </ng-container>
  <ng-container matColumnDef="ort">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Ort</th>
    <td mat-cell *matCellDef="let element">{{element.postleitzahl}} {{element.ort}}</td>
  </ng-container>
  <ng-container matColumnDef="uebernehmen">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button mat-raised-button color=accent class="lv-kunden-treffer-table-button" (click)="selectKunde(element)">Übernehmen</button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<mat-paginator [pageSize]="data.numberOfElements" [length]="data.totalElements"></mat-paginator>
